import {
  NewAssignmentGetters,
  NewAssignmentActions,
  NewAssignmentMutations
} from '@/app/features/assignments/features/new-assignment/new-assignment.keys';
import format from 'date-fns/format';

import { newAssignmentService as svc } from './new-assignment.service';

export const getInitialState = () => {
  return {
    newAssignment: {
      created_at: format(new Date(), 'YYYY-MM-DD'),
      contractor_id: null,
      contractor: {
        contractor_name: ''
      },
      client_id: null,
      client_name: '',
      client_reference_number: null,
      stakeholderClientContacts: [],
      stakeholderCommissions: [],
      rates: [],
      pay_period_type: null,
      submittal_period_type: null,
      branch_name: null,
      time_sheet_submittal: null,
      expense_submittal: null,
      occupation: '',
      reference_number: null,
      created_by_id: null,
      created_comment: '',
      status: 'DRAFT',
      start_date: '',
      stop_date: '',
      division_abbr: null,
      department_code: null,
      end_client_id: null,
      billingMethod: null,
      billing_method_id: null,
      work_order_number: '',
      client_number: '',
      payroll_number: '',
      week_end_day: null,
      deposit_slip_access: null,
      work_location_province_abbr: null,
      work_location_address_id: null,
      work_authorization: '',
      purchase_order_id: null,
      is_clerical: false,
      burden: 0.0,
      payrollee_code: null,
      is_referral: false,
      rebate_id: null,
      taxable_expense: 0.0,
      general_comments: '',
      pay_comments: '',
      bill_comments: '',
      external_notes: '',
      timesheet_comments: '',
      payrollNums: [],
      ibm_extra_info: '',
      ibmExtraInfo: {}
    }
  };
};

export const newAssignmentStore = {
  state: getInitialState,
  getters: {
    [NewAssignmentGetters.NewAssignment]: state => {
      return state.newAssignment;
    }
  },
  mutations: {
    [NewAssignmentMutations.SetAssignmentContractorSuccess]: (state, contractor) => {
      state.newAssignment.contractor_id = contractor.contractor_id;
      state.newAssignment.contractor = contractor;
      state.newAssignment.payrollNums = contractor.payrollNums;
    },
    [NewAssignmentMutations.SetAssignmentClientSuccess]: (state, payload) => {
      state.newAssignment.client_id = payload.client.id;
      state.newAssignment.client_name = payload.client.name;
      state.newAssignment.client_reference_number = payload.client.reference_number;

      payload.billingMethod
        ? (state.newAssignment.billing_method_id = payload.billingMethod.id)
        : null;
      state.newAssignment.billingMethod = payload.billingMethod;
    },
    [NewAssignmentMutations.SetAssignmentBranchSuccess]: (state, branchName) => {
      state.newAssignment.branch_name = branchName;
    },
    [NewAssignmentMutations.SetNewAssignmentSuccess]: state => {
      state.newAssignment = getInitialState().newAssignment;
    },
    [NewAssignmentMutations.ResetAssignmentClientSuccess]: state => {
      state.newAssignment.client_id = null;
      state.newAssignment.client_name = '';
      state.newAssignment.client_reference_number = null;
    }
  },
  actions: {
    [NewAssignmentActions.SetAssignmentContractor]: ({ commit }, contractor) => {
      commit(NewAssignmentMutations.SetAssignmentContractorSuccess, contractor);
    },
    [NewAssignmentActions.SetAssignmentClient]: ({ commit }, client) => {
      return svc.retrieveSelectedClientBillingMethod(client.id).then(res => {
        const defaultBillingMethod = res.filter(r => r.is_default)[0] || null;
        commit(NewAssignmentMutations.SetAssignmentClientSuccess, {
          client,
          billingMethod: defaultBillingMethod
        });
      });
    },
    [NewAssignmentActions.SetAssignmentBranch]: ({ commit }, branchName) => {
      commit(NewAssignmentMutations.SetAssignmentBranchSuccess, branchName);
    },
    [NewAssignmentActions.SetNewAssignment]: ({ commit }) => {
      commit(NewAssignmentMutations.SetNewAssignmentSuccess);
    },
    [NewAssignmentActions.ResetAssignmentClient]: ({ commit }) => {
      commit(NewAssignmentMutations.ResetAssignmentClientSuccess);
    }
  }
};
